import React from "react";
import "./bottom.css";
import LeftPage from "./LeftPage";
import RightPage from "./RightPage";
// import { useHistory } from "react-router-dom";

function Bottom({PaperEnd}) {
  // let history = useHistory();

  return (
    <div className="test-bottom">
      <div className="testLeft">
        <LeftPage PaperEnd={PaperEnd} />
      </div>
      <div className="testRight">
        <RightPage />
      </div>
    </div>
  );
}

export default Bottom;
